import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/apps/clients/')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login' });
    }
    // Redirect to existing clients page
    throw redirect({ to: '/clients' });
  },
});
